import { Component } from '@angular/core';

@Component({
  selector: 'app-banner',
  template: ``,
})
export class BannerComponent {}
